export default __webpack_public_path__ + "static/media/DOT.4489cc25.svg";